import { Component } from '@angular/core';

@Component({
  selector: 'site-referencedFilms',
  templateUrl: './referencedFilms.component.html',
  styleUrls: ['./referencedFilms.component.css']
})
export class ReferencedFilmsComponenet {

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/referencedFilms/referencedFilms.component.ts